import React, {Component} from 'react';
import '../flotante/Flotante.css';

class Flotante extends Component {
 
  render() {
 
   
  	return (
        <a href="https://api.whatsapp.com/send?phone=51996007529&text=Hola%21%20Quisiera%20m%C3%A1s%20informaci%C3%B3n%20sobre%20AiCredito%20." className="float" target="_blank">
            <i className="fa fa-whatsapp my-float"></i>
        </a>
  	)
    
  }
 
}
 
export default Flotante;